import { Api } from '@automapa/svelte-automapa-template';
import { z } from 'zod';

const PreviewSummarySchema = z.object({
    customer_name: z.string(),
    export_date: z.string(),
    export_version: z.string(),
    counts: z.object({
        collections: z.number(),
        lm_users: z.number(),
        warehouses: z.number(),
        maps: z.number(),
        tactical_plans: z.number(),
        vehicles: z.number(),
        vehicle_group_memberships: z.number(),
    }),
});

export type PreviewSummaryType = z.infer<typeof PreviewSummarySchema>;

const ImportResultSchema = z.object({
    new_customer_id: z.number(),
    summary: z.record(z.number()),
    id_mappings: z.record(z.record(z.number())).optional(),
});

export type ImportResultType = z.infer<typeof ImportResultSchema>;

export class CustomerAccountApi {
    private static _endpoint = 'customer_account';

    static async exportAccount(api: Api, customerId: number): Promise<Blob> {
        return api.getData<{ customer_id: number }, Blob>(
            'post',
            `/${this._endpoint}/export_account`,
            { customer_id: customerId },
            z.object({ customer_id: z.number() }),
            z.any(),
            'blob'
        );
    }

    static async previewImport(api: Api, accountData: object): Promise<PreviewSummaryType> {
        return api.getData<{ account_data: object }, PreviewSummaryType>(
            'post',
            `/${this._endpoint}/preview_import`,
            { account_data: accountData },
            z.object({ account_data: z.any() }),
            PreviewSummarySchema
        );
    }

    static async importAccount(api: Api, accountData: object, overrideWebusers = false): Promise<ImportResultType> {
        return api.getData<{ account_data: object; override_webusers: boolean }, ImportResultType>(
            'post',
            `/${this._endpoint}/import_account`,
            { account_data: accountData, override_webusers: overrideWebusers },
            z.object({ account_data: z.any(), override_webusers: z.boolean() }),
            ImportResultSchema
        );
    }
}
